var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row form-page-detail-body-container container-app-search",
      attrs: { id: "form-search-popover" }
    },
    [
      !_vm.load_first
        ? _c(
            "div",
            {
              staticClass: "d-flex align-items-center justify-content-center",
              staticStyle: { height: "400px", width: "100%" }
            },
            [_vm._m(0)]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.load_first && !_vm.showTable
        ? _c(
            "div",
            {
              staticClass: "d-flex align-items-center justify-content-center",
              staticStyle: { height: "400px", width: "100%" }
            },
            [_vm._v("\n    Column not found, please add column first\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showTable
        ? _c(
            "div",
            { staticClass: "table-column" },
            [
              _c(
                "v-server-table",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.load_first,
                      expression: "load_first"
                    }
                  ],
                  ref: "recordTableComponent",
                  staticClass: "jTable",
                  attrs: { columns: _vm.columns, options: _vm.table_options },
                  on: {
                    loading: _vm.loading,
                    loaded: _vm.loaded,
                    sorted: _vm.sortingColumn
                  },
                  scopedSlots: _vm._u([
                    _vm._l(Object.values(_vm.form_data.columns), function(i) {
                      return {
                        key: i.name,
                        fn: function(props) {
                          return _c(
                            "div",
                            {
                              key: i.id,
                              on: {
                                click: function($event) {
                                  _vm.openDetail(props.row)
                                }
                              }
                            },
                            [
                              i.type === "text" || i.type === "number"
                                ? _c("div", [_vm._v(_vm._s(props.row[i.name]))])
                                : _vm._e(),
                              _vm._v(" "),
                              i.type === "maps" && props.row[i.name]
                                ? _c("div", [
                                    _vm._v(_vm._s(props.row[i.name].address))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              i.type === "object" && props.row[i.name]
                                ? _c("div", [
                                    _vm._v(_vm._s(props.row[i.name].name))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              i.type === "[]text" || i.type === "[]number"
                                ? _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        props.row[i.name]
                                          ? props.row[i.name].join(", ")
                                          : ""
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              i.type === "boolean"
                                ? _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        props.row[i.name] ? "TRUE" : "FALSE"
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              i.type === "[]object"
                                ? _c(
                                    "div",
                                    _vm._l(props.row[i.name], function(item) {
                                      return _c("span", { key: item.id }, [
                                        _vm._v(_vm._s(item.name) + ", ")
                                      ])
                                    })
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              i.type === "timestamp"
                                ? _c("div", [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(props.row[i.name]) +
                                        "\n        "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              i.type === "person" && props.row[i.name]
                                ? _c("div", [
                                    _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "td" },
                                        [
                                          props.row[i.name].photo
                                            ? _c("b-img", {
                                                staticClass:
                                                  "m-1 round-bordered-img\n              img-circle staff-img image-popup-link b-page-theme td",
                                                attrs: {
                                                  src: props.row[i.name].photo,
                                                  rounded: "circle",
                                                  alt: "img"
                                                }
                                              })
                                            : _c("b-img", {
                                                staticClass:
                                                  "m-1 round-bordered-img\n              img-circle staff-img image-popup-link b-page-theme td",
                                                attrs: {
                                                  src: require("../../assets/logo/user1.png"),
                                                  rounded: "circle",
                                                  alt: "img"
                                                }
                                              })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "td p__t--7" }, [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(props.row[i.name].email)
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(_vm._s(props.row[i.name].name))
                                        ])
                                      ])
                                    ])
                                  ])
                                : _vm._e()
                            ]
                          )
                        }
                      }
                    }),
                    {
                      key: "delete_and_update",
                      fn: function(props) {
                        return _c("div", {}, [
                          _c("img", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showBtnEditData,
                                expression: "showBtnEditData"
                              }
                            ],
                            staticClass: "cursor-pointer m__r--5",
                            attrs: {
                              src: require("@/assets/icon/query/edit.svg"),
                              width: "13"
                            },
                            on: {
                              click: function($event) {
                                _vm.openDetail(props.row)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.showBtnEditData &&
                          _vm.form_data.type !== "thirdparty"
                            ? _c("img", {
                                staticClass: "cursor-pointer",
                                attrs: {
                                  src: require("@/assets/icon/query/delete.svg"),
                                  width: "13"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.deleteItem(props.row)
                                  }
                                }
                              })
                            : _vm._e()
                        ])
                      }
                    }
                  ])
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "custom-search",
                      attrs: { slot: "beforeFilter" },
                      slot: "beforeFilter"
                    },
                    [
                      _c(
                        "b-form",
                        { attrs: { inline: "" } },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showBtnEditData,
                                  expression: "showBtnEditData"
                                }
                              ],
                              staticClass: "btn grey btn-import-form m__r--5",
                              on: { click: _vm.openModalData }
                            },
                            [
                              _c("i", { staticClass: "fa fa-plus fa-lg" }),
                              _vm._v(" Add\n          ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "btn grey btn-import-form m__r--5",
                              attrs: { id: "filterServerPopover" }
                            },
                            [
                              _c("i", { staticClass: "fa fa-filter fa-lg" }),
                              _vm._v(" Filter\n          ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showBtnEditData,
                                  expression: "showBtnEditData"
                                }
                              ],
                              staticClass: "btn grey btn-import-form m__r--5",
                              on: {
                                click: function($event) {
                                  _vm.$refs.appImportRecordModal.show()
                                  _vm.dropboxImportShow = true
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-cloud-upload fa-lg"
                              }),
                              _vm._v(" Import\n          ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showBtnEditData,
                                  expression: "showBtnEditData"
                                }
                              ],
                              staticClass: "btn grey btn-import-form m__r--5",
                              on: { click: _vm.exportData }
                            },
                            [
                              _c("i", { staticClass: "fa fa-download fa-lg" }),
                              _vm._v(" Export\n          ")
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showTable
        ? _c(
            "b-popover",
            {
              ref: "filterServerPopoverRef",
              attrs: {
                show: _vm.popoverFilterServerShow,
                container: "form-search-popover",
                target: "filterServerPopover",
                placement: "top"
              },
              on: {
                "update:show": function($event) {
                  _vm.popoverFilterServerShow = $event
                }
              }
            },
            [
              _c(
                "b-form",
                {
                  attrs: { inline: "" },
                  on: {
                    keypress: function($event) {
                      if (!("button" in $event) && $event.keyCode !== 13) {
                        return null
                      }
                      $event.preventDefault()
                      _vm.$refs.recordTableComponent.setFilter(_vm.filter_data)
                      _vm.popoverFilterServerShow = false
                    }
                  }
                },
                [
                  _c("j-single-select", {
                    staticClass: "m__r--5",
                    staticStyle: { width: "200px" },
                    attrs: {
                      options: _vm.options_search,
                      "error-required": false,
                      placeholder: "Filter By",
                      label: "name"
                    },
                    model: {
                      value: _vm.select_type,
                      callback: function($$v) {
                        _vm.select_type = $$v
                      },
                      expression: "select_type"
                    }
                  }),
                  _vm._v(" "),
                  _vm.cekTypeData(_vm.select_type) === "timestamp"
                    ? _c(
                        "span",
                        { staticClass: "reimb-select-period m__r--5" },
                        [
                          _c("j-datepicker", {
                            staticClass: "m__r--5",
                            attrs: {
                              "error-required": false,
                              placeholder: "Start Date",
                              format: "MMM dd, yyyy"
                            },
                            model: {
                              value: _vm.filter_data_start_date,
                              callback: function($$v) {
                                _vm.filter_data_start_date = $$v
                              },
                              expression: "filter_data_start_date"
                            }
                          }),
                          _vm._v(" "),
                          _c("j-datepicker", {
                            attrs: {
                              "disabled-dates": _vm.disableDates(
                                _vm.filter_data_start_date
                              ),
                              "error-required": false,
                              placeholder: "End Date",
                              format: "MMM dd, yyyy"
                            },
                            model: {
                              value: _vm.filter_data_end_date,
                              callback: function($$v) {
                                _vm.filter_data_end_date = $$v
                              },
                              expression: "filter_data_end_date"
                            }
                          })
                        ],
                        1
                      )
                    : _c("b-form-input", {
                        staticStyle: { width: "250px !important" },
                        attrs: { placeholder: "Search" },
                        model: {
                          value: _vm.filter_data,
                          callback: function($$v) {
                            _vm.filter_data = $$v
                          },
                          expression: "filter_data"
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appAddRecordModal",
          staticClass: "mod-form modal-add-record-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("CREATE RECORD")
          ]),
          _vm._v(" "),
          _vm.showRecord
            ? _c("j-form-record", {
                ref: "jFormCreate",
                attrs: {
                  "data-fields": _vm.dataFields,
                  "is-detail": _vm.isDetail
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeCreateData }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.createRecordData }
                      },
                      [_vm._v("\n            Submit\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appEditRecordModal",
          staticClass: "mod-form modal-add-record-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("EDIT RECORD")
          ]),
          _vm._v(" "),
          _c("label", [_vm._v(" JSON ")]),
          _vm._v(" "),
          _vm.showCodeEditor
            ? _c("j-monaco-editor", {
                ref: "scriptEditor",
                staticClass: "m__t--10",
                attrs: {
                  value: _vm.jsonData,
                  disable: !_vm.showBtnEditData,
                  language: "json"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showBtnEditData,
                          expression: "showBtnEditData"
                        }
                      ],
                      staticClass: "btn red",
                      on: { click: _vm.deleteRecordData }
                    },
                    [_vm._v("\n          Delete\n        ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "8" } }, [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeDetail }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showBtnEditData,
                            expression: "showBtnEditData"
                          }
                        ],
                        staticClass: "btn blue",
                        on: { click: _vm.updateRecordData }
                      },
                      [_vm._v("\n            Update\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appImportRecordModal",
          staticClass: "mod-form modal-add-form-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("IMPORT")
          ]),
          _vm._v(" "),
          _vm.dropboxImportShow
            ? _c("div", { staticClass: "dropbox-oos" }, [
                _c("input", {
                  staticClass: "input-file",
                  attrs: { type: "file", multiple: "" },
                  on: {
                    change: function($event) {
                      _vm.handleFileUpload($event.target.files)
                    }
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  attrs: { src: require("@/assets/form-data/file-dropbox.png") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "label-dropbox" }, [
                  _vm._v("Drop your file here, or "),
                  _c("span", [_vm._v("browse")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "label-support-dropbox" }, [
                  _vm._v("Support : ZIP")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray",
                        on: { click: _vm.closeImportForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ellipsis" }, [
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d0b52ed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d0b52ed","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data-manager/jFormData.vue
// module id = null
// module chunks = 